<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '700px', maxHeight: '80vh' }"
  header="Tracking Timeline"
  (onHide)="close()"
>
  <div class="tracking-timeline" *ngIf="email">
    <!-- Header con info básica del email -->
    <div class="timeline-header mb-4">
      <h4 class="email-subject">
        <i class="fa-solid fa-envelope"></i>
        {{ email.subject }}
      </h4>
      <p class="email-recipient">
        <i class="fa-solid fa-at"></i>
        {{ email.recipientEmail || email.to }}
      </p>
    </div>

    <!-- Timeline vertical -->
    <p-timeline 
      *ngIf="events.length > 0"
      [value]="events" 
      align="left"
      [styleClass]="'custom-timeline'"
    >
      <ng-template pTemplate="content" let-event>
        <div class="timeline-event">
          <div class="event-header">
            <i [class]="event.icon" [style.color]="event.color"></i>
            <strong>{{ event.label }}</strong>
            <span *ngIf="event.count" class="event-count">
              ({{ event.count }}x)
            </span>
          </div>

          <div class="event-time">
            <div class="event-date">{{ formatDate(event.timestamp) }}</div>
            <small class="event-diff">{{ getTimeDiff(event.timestamp) }}</small>
          </div>

          <div class="event-details" *ngIf="event.reason || event.error">
            <div class="detail-item" *ngIf="event.reason">
              <strong>Razón:</strong>
              <p>{{ event.reason }}</p>
            </div>
            <div class="detail-item error-detail" *ngIf="event.error">
              <strong>Error:</strong>
              <p>{{ event.error }}</p>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="marker" let-event>
        <div 
          class="timeline-marker" 
          [style.background-color]="event.color"
          [class.has-count]="event.count"
        >
          <i [class]="event.icon"></i>
          <span *ngIf="event.count" class="marker-count">{{ event.count }}</span>
        </div>
      </ng-template>
    </p-timeline>

    <!-- Mensaje si no hay eventos -->
    <div *ngIf="events.length === 0" class="no-events">
      <i class="fa-solid fa-clock"></i>
      <p>No hay eventos de tracking registrados</p>
      <small>Los eventos aparecerán aquí una vez que el email sea procesado</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button 
        pButton 
        label="Cerrar" 
        icon="fa-solid fa-times"
        class="p-button-secondary"
        (click)="close()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
